



















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { LoanControlForm } from '@/models/dailyControl'
import { EmployeeModel } from '@/models/config'

// Components
import { FormCreateEditLoanControl } from '@/components/dailyControl'

@Component({
    name: 'ModalCreateEditLoanControl',
    components: {
        FormCreateEditLoanControl
    }
})
export default class ModalCreateEditLoanControl extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) loanControl!: LoanControlForm
    @Prop({ type: Array, default: () => [] }) employees!: EmployeeModel[]

    get title () {
        if (this.actionForm === 'save') {
            return 'Agregar Control de Prestamos de Empleados'
        }
        return 'Agregar Control de Prestamos de Empleados'
    }
}
